import { Component, OnInit } from '@angular/core';
import { TasksService } from '../shared/services/tasks.service';
import { UpcomingTask } from '../shared/models/upcoming-tasks';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { SVGIcon, fileVideoIcon, warningCircleIcon } from '@progress/kendo-svg-icons';
import { TaskType } from '../shared/enums/task-type';
import { AttachmentService } from '../shared/services/attachments.service';
import { OfflineAttachment } from '../shared/models/offline-attachments';
import { StringConstants } from '@app/shared/string-constants';
import { ResourceService } from '../shared/services/resource.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuditsService } from '../shared/services/audits.service';
import { PageChangeEvent } from '@progress/kendo-angular-pager';
import { NotificationService } from '@progress/kendo-angular-notification';
import { auditIcon, circlePlayIcon, documentIcon, offlineTrainingIcon, trainingIcon } from '@app/shared/customSVGIcons/custom-svg';
import { TaskNotification } from '../shared/models/task-notification';

@Component({
	selector: 'kpa-opentasks',
	templateUrl: './opentasks.component.html',
	styleUrl: './opentasks.component.scss',
})
export class OpentasksComponent implements OnInit {
	public viewOpenTasks: boolean = false;
	public upcomingTasksList: UpcomingTask[] = [];
	public pagedTasks: UpcomingTask[] = [];
	public isMobile: boolean = false;
	public warningIcon: SVGIcon = warningCircleIcon;
	public filevideoIcon: SVGIcon = fileVideoIcon;
	public circlePlayIcon: SVGIcon = circlePlayIcon;
	public documentIcon: SVGIcon = documentIcon;
	public trainingIcon: SVGIcon = trainingIcon;
	public offlineTrainingIcon: SVGIcon = offlineTrainingIcon;
	public auditIcon: SVGIcon = auditIcon;
	public dialogOpened: boolean = false;
	public isDocumentType: boolean = false;
	public isLinkType: boolean = false;
	public isOfflineTrainingType: boolean = false;
	public isSafetyVideo: boolean = false;
	public isAudit: boolean = false;

	public offlineAttachments: OfflineAttachment[] = [];
	public title: string = '';
	public linkUrl: string = '';
	public docId: string;
	public contentURL: SafeResourceUrl;
	private intervalId: any;
	public currentAuditId: number;
	public scheduledId: number;

	public isMarcom: boolean = false;
	selectedSortOption = { text: 'Due Date (Asc)', value: 'dueDateAsc' };
	sortOptions = [
		{ text: 'Title (A-Z)', value: 'titleAsc' },
		{ text: 'Title (Z-A)', value: 'titleDesc' },
		{ text: 'Type (A-Z)', value: 'typeAsc' },
		{ text: 'Type (Z-A)', value: 'typeDesc' },
		{ text: 'Due Date (Asc)', value: 'dueDateAsc' },
		{ text: 'Due Date (Desc)', value: 'dueDateDesc' },
	];
	public noTaskScheduledMessage: string = StringConstants.noTaskScheduledMessage;
	public buttonCount = 5;
	public sizes = [5, 10, 20, 50];
	public pageSize: number = 5;
	public skip: number = 0;
	public total = 0;
	private popupWindow: Window | null = null;
	private dialogClosed: boolean = false;
	constructor(
		private tasksService: TasksService,
		private attachmentService: AttachmentService,
		private breakpointObserver: BreakpointObserver,
		private resourceService: ResourceService,
		private sanitizer: DomSanitizer,
		private notificationService: NotificationService
	) {}

	ngOnInit() {
		this.breakpointObserver.observe([Breakpoints.Handset]).subscribe((result) => {
			this.isMobile = result.matches;
			if (!this.isMobile) {
				this.isMobile = false;
			}
		});
		this.getUpcomingTasks();
	}
	getUpcomingTasks() {
		this.upcomingTasksList = [];
		this.tasksService.getUpcomingTasks().subscribe((result: UpcomingTask[]) => {
			this.upcomingTasksList = result;
			this.viewOpenTasks = true;
			this.total = this.upcomingTasksList.length;
			this.sortTasks();
		});
	}

	private pageData(upcomingTasksList: UpcomingTask[]): void {
		this.pagedTasks = upcomingTasksList.slice(this.skip, this.skip + this.pageSize);
	}

	onPageChange(e: PageChangeEvent): void {
		this.skip = e.skip;
		this.pageSize = e.take;
		this.pageData(this.upcomingTasksList);
	}

	sortTasks() {
		const sortValue = this.selectedSortOption.value;
		if (sortValue === 'titleAsc') {
			this.upcomingTasksList.sort((a, b) => a.title.localeCompare(b.title));
		} else if (sortValue === 'titleDesc') {
			this.upcomingTasksList.sort((a, b) => b.title.localeCompare(a.title));
		} else if (sortValue === 'typeDesc') {
			this.upcomingTasksList.sort((a, b) => b.type.localeCompare(a.type));
		} else if (sortValue === 'typeAsc') {
			this.upcomingTasksList.sort((a, b) => a.type.localeCompare(b.type));
		} else if (sortValue === 'dueDateAsc') {
			this.upcomingTasksList.sort((a, b) => {
				if (!a.due && !b.due) {
					return 0;
				} else if (!a.due) {
					return 1;
				} else if (!b.due) {
					return -1;
				}
				return new Date(a.due).getTime() - new Date(b.due).getTime();
			});
		} else if (sortValue === 'dueDateDesc') {
			this.upcomingTasksList.sort((a, b) => {
				if (!a.due && !b.due) {
					return 0;
				} else if (!a.due) {
					return 1;
				} else if (!b.due) {
					return -1;
				}
				return new Date(b.due).getTime() - new Date(a.due).getTime();
			});
		}
		this.pageData(this.upcomingTasksList);
	}
	getContentType(type: string, contentType: number): string {
		switch (type) {
			case TaskType.Audit:
				return 'Audit';
			case TaskType.Document:
				if (contentType !== 3) {
					return 'Document';
				} else if (contentType == 3) {
					return 'Link';
				}
			case TaskType.OnlineTraining:
				return 'Online Training';
			case TaskType.OfflineTraining:
				return 'Offline Training';
			case TaskType.Video:
				return 'Video';
			default:
				return 'n/a';
		}
	}
	public closeDialog() {
		this.isDocumentType = false;
		this.isLinkType = false;
		this.isOfflineTrainingType = false;
		this.isSafetyVideo = false;
		this.isAudit = false;
		this.getUpcomingTasks();
	}

	public handleDocumentAction() {
		this.closeDialog();
	}
	public taskCompleted(taskNotification: TaskNotification) {
		if (taskNotification.isCompleted) {
			this.notificationService.show({
				content: 'Task Completed',
				hideAfter: StringConstants.hideNotificationAfter,
				position: { horizontal: 'center', vertical: 'top' },
				animation: { type: 'fade', duration: 400 },
				type: { style: 'success', icon: true },
			});
		}
		if (taskNotification.isReviewed) {
			this.notificationService.show({
				content: 'Document Reviewed',
				hideAfter: StringConstants.hideNotificationAfter,
				position: { horizontal: 'center', vertical: 'top' },
				animation: { type: 'fade', duration: 400 },
				type: { style: 'success', icon: true },
			});
		}
	}
	public openTask(task: UpcomingTask) {
		let type = this.getTaskType(task);
		if (type === TaskType.Document && task.contentType !== 3) {
			this.isDocumentType = true;
			this.title = task.title;
			this.docId = task.externalId;
		} else if (type === TaskType.Document && task.contentType === 3) {
			this.isLinkType = true;
			this.title = task.title;
			this.linkUrl = task.url;
			this.docId = task.externalId;
		} else if (type === TaskType.OfflineTraining) {
			this.openOfflineTrainingDialog(task);
		} else if (type === TaskType.Video || type === TaskType.OnlineTraining) {
			this.openSafetyVideoDialog(task);
		} else if (type === TaskType.Audit) {
			this.openAuditDialog(task);
		}
		if (this.isDocumentType || this.isOfflineTrainingType) {
			this.title = task.title;
		}
	}

	public openOfflineTrainingDialog(task: UpcomingTask) {
		this.attachmentService.getOfflineAttachment(task.scheduledTrainingId).subscribe((result) => {
			this.offlineAttachments = result;
			this.isOfflineTrainingType = true;
		});
	}

	public openAuditDialog(task: UpcomingTask) {
		this.currentAuditId = task.id;
		this.isAudit = true;
	}
	public openSafetyVideoDialog(task: UpcomingTask) {
		// Check if it's Safari
		const isSafari = () => {
			const ua = window.navigator.userAgent.toLowerCase();
			return ua.includes('safari') && !ua.includes('chrome');
		};

		// Close the previous popup if it's still open
		if (this.popupWindow && !this.popupWindow.closed) {
			this.popupWindow.close();
		}

		// Store the URL first
		this.resourceService.getContentURL(task.externalId).subscribe((result) => {
			this.contentURL = this.sanitizer.bypassSecurityTrustResourceUrl(result);

			// Open the video depending on the task type
			if (task.type == TaskType.Video) {
				this.isMarcom = task.isMarcom;
				this.scheduledId = task.scheduledTrainingId;
				this.isSafetyVideo = true;
			} else {
				if (isSafari()) {
					// Use setTimeout to handle Safari pop-up issue
					setTimeout(() => {
						const newTab = window.open(result, '_blank');

						if (newTab) {
							// Detect when the tab is closed
							const checkTabClosedInterval = setInterval(() => {
								if (newTab.closed) {
									clearInterval(checkTabClosedInterval);
									this.closeDialog();
								}
							}, 500);
						}
					}, 100); // Small delay to ensure the popup works correctly on Safari
				} else {
					this.popupWindow = window.open(result, 'LMS', 'width=1024,height=672,menubar=0,status=0,titlebar=0,toolbar=0,resizable=1');

					// Handle popup close detection
					this.dialogClosed = false;
					if (this.popupWindow) {
						this.intervalId = setInterval(() => {
							if (this.popupWindow.closed && !this.dialogClosed) {
								clearInterval(this.intervalId);
								this.dialogClosed = true;
								this.closeDialog();
							}
						}, 500);
					}
				}
			}
		});
	}

	public getTaskType(task: UpcomingTask) {
		switch (task.type) {
			case 'Audit':
				return TaskType.Audit;
			case 'Document':
				return TaskType.Document;
			case 'OnlineTraining':
				return TaskType.OnlineTraining;
			case 'OfflineTraining':
				return TaskType.OfflineTraining;
			case 'Video':
				return TaskType.Video;
			default:
				return TaskType.None;
		}
	}
}
